<div
class="loading-placeholder"
style="
position: fixed;
top: 0;
left: 0;
right: 0
;bottom: 0;
z-index: 7777;
display: flex;
justify-content: center;
align-items: center;
background: var(--primary-color);
"
*ngIf="is_loader_displayed"
>
  <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 20px;">

    <span class="app-logo ms-1"></span>

  </div>

</div>